
import tw from "tailwind-styled-components"

export const Container = tw.aside`
   flex
   flex-col
   max-w-6xl
   m-auto
`;